import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { types as api } from '@mesa-labs/mesa-api';
import { DefaultPaginationDropdownLimits, PaginationDropdownLimit } from '@mesa-labs/mesa-ui/dist/components/Pagination';

export type ProgramPromotionsState = {
  searchTerm?: string;
  page?: number;
  totalPages?: number;
  limit?: PaginationDropdownLimit;
  sortField?: string;
  sortDirection?: api.SortDirection;
  statusFilter?: api.VendorProgramPromotionStatus;
  partnerFilter?: api.Partners;
  programCodeFilter?: string;
  promoCodeFilter?: string;
  typeFilter?: api.VendorProgramPromotionType;
};

const initialState: ProgramPromotionsState = {
  searchTerm: '',
  page: 1,
  totalPages: undefined,
  limit: DefaultPaginationDropdownLimits[0],
  sortField: 'createdAt',
  sortDirection: api.SortDirection.DESCENDING,
  statusFilter: undefined,
  partnerFilter: undefined,
  programCodeFilter: undefined,
  promoCodeFilter: undefined,
  typeFilter: undefined,
};

const programPromotionsSlice = createSlice({
  name: 'programPromotions',
  initialState,
  reducers: {
    updateSearchTerm(state: ProgramPromotionsState, action: PayloadAction<string>) {
      state.searchTerm = action.payload;
      state.page = 1;
    },
    updatePage(state: ProgramPromotionsState, action: PayloadAction<number>) {
      state.page = action.payload;
    },
    updateTotalPages(state: ProgramPromotionsState, action: PayloadAction<number>) {
      state.totalPages = action.payload;
    },
    updateLimit(state: ProgramPromotionsState, action: PayloadAction<PaginationDropdownLimit>) {
      state.limit = action.payload;
    },
    updateSortField(state: ProgramPromotionsState, action: PayloadAction<string>) {
      state.sortField = action.payload;
    },
    updateSortDirection(state: ProgramPromotionsState, action: PayloadAction<api.SortDirection>) {
      state.sortDirection = action.payload;
    },
    updateStatusFilter(state: ProgramPromotionsState, action: PayloadAction<api.VendorProgramPromotionStatus | undefined>) {
      state.statusFilter = action.payload;
      state.page = 1;
    },
    updatePartnerFilter(state: ProgramPromotionsState, action: PayloadAction<api.Partners | undefined>) {
      state.partnerFilter = action.payload;
      state.page = 1;
    },
    updateProgramCodeFilter(state: ProgramPromotionsState, action: PayloadAction<string | undefined>) {
      state.programCodeFilter = action.payload;
      state.page = 1;
    },
    updatePromoCodeFilter(state: ProgramPromotionsState, action: PayloadAction<string | undefined>) {
      state.promoCodeFilter = action.payload;
      state.page = 1;
    },
    updateTypeFilter(state: ProgramPromotionsState, action: PayloadAction<api.VendorProgramPromotionType | undefined>) {
      state.typeFilter = action.payload;
      state.page = 1;
    },
  },
});

export const {
  updateSearchTerm,
  updatePage,
  updateTotalPages,
  updateLimit,
  updateSortField,
  updateSortDirection,
  updateStatusFilter,
  updatePartnerFilter,
  updateProgramCodeFilter,
  updatePromoCodeFilter,
  updateTypeFilter,
} = programPromotionsSlice.actions;
export default programPromotionsSlice.reducer;
